module.exports = __webpack_public_path__ + "static/media/Gapy_Crop.125d34b9.PNG";